mutation ForgotUserPassword($usernameOrEmail: String!) {
  forgotUserPassword(usernameOrEmail: $usernameOrEmail) {
    ok
    errors
  }
}
